var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTimeOutline = function SvgTimeOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.83 15.42a.5.5 0 0 0 .066-.704L12.5 11.822V6.96a.5.5 0 0 0-1 0V12a.5.5 0 0 0 .115.32l2.511 3.033a.498.498 0 0 0 .704.067ZM12 4.126c-4.342 0-7.875 3.533-7.875 7.877 0 4.341 3.533 7.873 7.876 7.873 4.342 0 7.874-3.532 7.874-7.873 0-4.344-3.532-7.877-7.874-7.877Zm0 16.75c-4.894 0-8.875-3.98-8.875-8.873 0-4.895 3.981-8.877 8.876-8.877 4.893 0 8.874 3.982 8.874 8.877 0 4.893-3.981 8.873-8.874 8.873Z",
    fill: "currentColor"
  })));
};
export default SvgTimeOutline;